export class UIDPressKitSceneController {
    hide() {
        this.pressKitSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.pressKitSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.pressKitSceneContainerDiv = document.getElementById('scene_discord_press_kit_container');
    }
}
